module.exports = __webpack_public_path__ + "img/p30616.386fe6cd.jpg";